export default __webpack_public_path__ + "static/media/Nourishing Thoughts.83e94569.jpg";